import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-2">SERVICE CARDS</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">服务保障</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            吃瓜网站为您提供全方位的访问保障与内容服务
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card, i) => (
            <div key={i} className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-background-300 transition-colors">
              <div className="relative w-full h-44 overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 3 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <span className="absolute bottom-3 left-3 text-[10px] font-semibold px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${card.icon} text-primary-600 text-sm`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm">{card.title}</h3>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{card.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}